<div class="table-responsive" [class.overflow-hidden]="websiteBuilderService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
        <tr [ngClass]="{'noSort': websiteBuilderService.data.corporations.data.length < 2}">
            <th class="footable-sorted" (click)="orderBy('corporationNumber', $event)">
                Corporation <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteUrl', $event)">
                Website Url <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('status', $event)">
                Published <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteTitle', $event)">
                Title <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteWelcome.status', $event)">
                Welcome <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteAboutUs.status', $event)">
                About Us <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteGallery.status', $event)">
                Gallery <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteBuildingFeatures.status', $event)">
                Features <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteNeighbourhood.status', $event)">
                Neighbourhood <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteContact.status', $event)">
                Contacts <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteDocument.status', $event)">
                Documents <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('websiteAnnouncements.status', $event)">
                Announcements <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('updatedAt', $event)">
                Updated At <span class="footable-sort-indicator"></span>
            </th>
            <th (click)="orderBy('updatedBy.fullName', $event)">
                Updated By <span class="footable-sort-indicator"></span>
            </th>
        </tr>
        </thead>
        <tbody>
        <ng-template ngFor let-item [ngForOf]="websiteBuilderService.data.corporations.data" let-index="index">
            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="$event.showDropdown || toggleCheck(item)">
                <td>{{item.corporationNumber}}</td>
                <td>{{item.websiteUrl}}</td>
                <td>
                    <i *ngIf="item.status" class="icon-check"></i>
                    <i *ngIf="!item.status" class="icon-close"></i>
                </td>
                <td>{{item.websiteTitle}}</td>
                <td>
                    <i *ngIf="item.websiteWelcome?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteWelcome?.status" class="icon-close"></i>
                </td>
                <td>
                    <i *ngIf="item.websiteAboutUs?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteAboutUs?.status" class="icon-close"></i>
                </td>
                <td>
                    <i *ngIf="item.websiteGallery?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteGallery?.status" class="icon-close"></i>
                </td>
                <td>
                    <i *ngIf="item.websiteBuildingFeatures?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteBuildingFeatures?.status" class="icon-close"></i>
                </td>
                <td>
                    <i *ngIf="item.websiteNeighbourhood?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteNeighbourhood?.status" class="icon-close"></i>
                </td>
                <td>
                    <i *ngIf="item.websiteContact?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteContact?.status" class="icon-close"></i>
                </td>
                <td>
                    <i *ngIf="item.websiteDocument?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteDocument?.status" class="icon-close"></i>
                </td>
                <td>
                    <i *ngIf="item.websiteAnnouncements?.status" class="icon-check"></i>
                    <i *ngIf="!item.websiteAnnouncements?.status" class="icon-close"></i>
                </td>
                <td>{{item.updatedAt | mccDate:true:true}}</td>
                <td>{{item.updatedBy?.fullName}}</td>
            </tr>
        </ng-template>
        <tr *ngFor="let item of websiteBuilderService.emptyRowService.emptyRow" style="cursor: default;">
            <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
            <td></td><td></td><td></td><td></td><td></td><td></td><td></td>
        </tr>
        </tbody>
    </table>
    <div *ngIf="websiteBuilderService.data.corporations.data.length === 0 && !websiteBuilderService.spinnerShow && !websiteBuilderService.showServiceUnavailable"
         class=" text-center">
        <h2>Result Not Found</h2>
        <a class="text-center">
            <broad-match-toggle></broad-match-toggle>
        </a>
    </div>
    <h2 *ngIf="websiteBuilderService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/website-builder/corporations-list/corporations-list.component.html